export default __webpack_public_path__ + "static/media/phone-spotify.1f907862.png";